import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import "../css/landing.css";
import Rightcontainer from "../Components/Rightcontainer";
import Downloadbutton from "../Components/Downloadbutton";
import DownloadPopup from "../Components/DownloadPopup";
import io from "../Components/socket";
import Header from "../Components/Header";
import { Token } from "@mui/icons-material";
import SliderCode from "../Components/SliderCode";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false);
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);
  const udata = localStorage.getItem("udata");

  let profileData = JSON.parse(udata);
  // const [userAllData, setUserAllData] = useState()

  // language
  const translations = {
    hi: { Tournaments: "प्रतियोगिता" },
    en: { Tournaments: "Tournaments" },
  };
  const { language } = useContext(LanguageContext);

  const MyData = localStorage.getItem("meData");
  const meedata = JSON.parse(MyData);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  

  useEffect(() => {
    // role()
  }, []);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "#fff",
    // padding: '20px',
    // margin: '20px',
  };

  const styles3 = {
    backgroundColor: theme === "light" ? "#facc06" : "#27241b",
    color: theme === "light" ? "black" : "#fff",
  };

  useEffect(() => {
    // console.log("ok");
    const UserId = localStorage.getItem("userId");
    socket.on("setProfile", (data) => {
      profileData = data;

      // userId = data?._id;
    });
  }, [socket]);

  const history = useHistory();
  const handleClick = (e) => {
    if (profileData?.verified === "unverified") {
      e.preventDefault(); // page pe jaane se roke
      Swal.fire({
        icon: "warning",
        html: `
    <h4 style="color:white; margin-bottom:10px;">
      Please complete KYC
    </h4>
    <p style="color:white;">
      You need to complete your KYC before proceeding.
    </p>
  `,
        background: "linear-gradient(135deg, #1e3a8a, #0f172a)",
        confirmButtonText: "Verify Now",
        confirmButtonColor: "#f59e0b",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/Profile"); // ✅ redirect
        }
      });

      return;
    }
    history.push("/");
  };

  return (
    <>
      {showDownloadPopup ? (
        <DownloadPopup onClose={() => setShowDownloadPopup(false)} />
      ) : null}
      <div
        className="leftContainer mb_space"
        style={{ ...styles, height: "119% !important" }}
      >

        {(() => {
          const token = localStorage.getItem("token");
          const sitSetting = JSON.parse(localStorage.getItem("sitSetting"));
          if (!sitSetting) return null;

          return (
           <div className="empire_home_main">

            {/* NOTICE BAR */}
            {(() => {
              return (
                    <div className="welcome_notice">
                      <span>
                        {token
                          ? sitSetting?.site_message
                          : sitSetting?.maintenence_msg}
                      </span>
                    </div>
                  );
                })()}

                {/* TOP SLIDER */}
                <div className="top_banner_main">
                  <SliderCode />
                </div>

                {/* INFO CARDS */}
                <div className="info_cards_row">

                  

                </div>

                {/* GAMES SECTION */}
                <section className="games-section">

                  <div className="games_grid_main">

                    {/* LUDO CLASSIC */}
                    <Link
                      className="new_game_card"
                      to={
                        addCaseSetting?.isLudokingClassic
                          ? "/Homepage/ludoClassicManual"
                          : "#"
                      }
                      onClick={(e) => {
                        if (!addCaseSetting?.isLudokingClassic) {
                          e.preventDefault();
                          return;
                        }

                        handleClick(e);
                      }}
                    >

                      {/* <span className="live_badge">
                        {addCaseSetting?.isLudokingClassic
                          ? "LIVE NOW"
                          : "COMING SOON"}
                      </span> */}

                      <picture>
                        <img
                          src={`${process.env.PUBLIC_URL}/mainimage/ludoclassic2.jpg`}
                          alt="Ludo Classic"
                          className="game_main_img"
                        />
                      </picture>

                      
                    </Link>

                    {/* SUPPORT */}
                    {/* <Link
                      className="new_game_card support_card_new"
                      to={
                        addCaseSetting?.EmpireludoOneGoti
                          ? "/Homepage/nksupport1"
                          : "#"
                      }
                    >

                      {/* <span className="coming_badge">
                        COMING SOON
                      </span> 

                      <picture>
                        <img
                          src="./mainimage/ludosupport.png"
                          alt="Support"
                          className="game_main_img"
                        />
                      </picture>
                    </Link> */}

                  </div>

                </section>

                {/* SOCIAL BUTTONS */}
                {/* <div className="social_btns_main">

                  

                  {/* WHATSAPP */}
                  {/* {(() => {

                    const token = localStorage.getItem("token");
                    const sitSetting = JSON.parse(localStorage.getItem("sitSetting"));

                    if (!token || !sitSetting) return null;

                    if (sitSetting.isChatSupport && sitSetting.whatsappSupport) {

                      return (
                        <a
                          className="social_card whatsapp_bg"
                          href={sitSetting.whatsappSupport}
                          target="_blank"
                          rel="noopener noreferrer"
                        >

                          <img
                            src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                            alt="Whatsapp"
                          />

                          <div>
                            <h4>Chat on WhatsApp</h4>
                            <p>We reply instantly!</p>
                            </div>
                            <button className="know_more_btn socialcard">
                           →
                        </button>
                          

                        </a>
                      );
                    }

                    return null;

                  })()} */}

                  {/* TELEGRAM */}
                  {/* {(() => {

                    const token = localStorage.getItem("token");
                    const sitSetting = JSON.parse(localStorage.getItem("sitSetting"));

                    if (!token || !sitSetting) return null;

                    if (sitSetting.isChatSupport && sitSetting.supportTelegram) {

                      return (
                        <a className="social_card telegram_bg" href={sitSetting.supportTelegram}                          target="_blank"
                          rel="noreferrer" >
                           <img src={process.env.PUBLIC_URL + "/images/telegram.png"} alt="Telegram"
                          />

                          <div>
                            <h4>Join on Telegram</h4>
                            <p>Updates & Offers</p>
                          </div>

                          <button className="know_more_btn socialcard">
                           →
                        </button>

                        </a>
                      );
                    }

                    return null;

                  })()} 

                </div> */}

                {/* <div>
                        {(() => {
                          const token = localStorage.getItem("token");
                          const sitSetting = JSON.parse(localStorage.getItem("sitSetting"));

                          // agar token ya sitSetting missing ho to kuch na dikhaye
                          if (!token || !sitSetting) return null;

                          if (sitSetting.isChatSupport && sitSetting.whatsappSupport) {
                            return (
                              <a
                                className="support_samll_card_btn_type whatsap_btn"
                                style={{ bottom: "160px" }}
                                href={sitSetting.whatsappSupport}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  width="40px"
                                  src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                                  alt="whatsapp"
                                />
                              </a>
                            );
                          }

                          return null;
                        })()}
                  </div> */}
              </div>
                );
              })()}
                {/* <div className='downloadButton'>
              <Downloadbutton />
            </div> */}


              </div>


            <div className="rightContainer">
              <Rightcontainer />
            </div>
    </>
  );
}
